import React, {Component} from "react";
// import './App.css';
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import {BrowserRouter, Link, Route, Switch} from 'react-router-dom';
import LoginForm from './components/LoginForm';
import PackageList from './components/PackageList';
import Storage from './Storage';
import PackageDetails from "./components/PackageDetails";
import PackageForm from "./components/PackageForm";
import Alert from "react-bootstrap/Alert";
import Profile from './components/Profile';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import registerIcons from "./registerIcons";
import JwtClient from "./JwtClient";
import UpdatePackage from "./components/UpdatePackage";
import StaffAddClient from "./StaffAddClient";
import Rate from "./components/Rate";
import StatusList from "./components/StatusList";


registerIcons();

class App extends Component {
    state = {error: '', showProfile: false};

    render() {
        if (this.state.error) {
            return <Alert variant="danger">{this.state.error}</Alert>
        }
        if (Storage.getIsStaff()) {
            return <StaffAddClient/>
        }
        if (!Storage.getEmail()) {
            return <LoginForm Storage={Storage} JwtClient={JwtClient}/>
        }
        return (
            <BrowserRouter>
                <Navbar bg="light" expand="lg">
                    <Container>
                        <Navbar.Brand href="/">Velox account</Navbar.Brand>
                        <Navbar.Toggle/>
                        <Navbar.Collapse>
                            <Nav>
                                <Link to="/" className="nav-link">Packages</Link>
                                <Link to="/package/add" className="nav-link">Add Package</Link>
                                {Storage.isHumAid() ?
                                    <Link to="/rate" className="nav-link">Rate</Link>
                                    : null
                                }
                                <Link to="/status-list" className="nav-link">Statuses</Link>
                            </Nav>
                            <Nav className="ml-auto">
                                <Nav.Link onClick={this.handleShowProfile}>
                                    <FontAwesomeIcon icon="cog"/>
                                    <span className="ml-1">Settings</span>
                                </Nav.Link>
                            </Nav>
                        </Navbar.Collapse>
                        <Profile
                            show={this.state.showProfile}
                            handleClose={this.handleCloseProfile}
                        />
                    </Container>
                </Navbar>
                <Container>
                    <Switch>
                        <Route exact path="/" component={PackageList}/>
                        <Route path="/package/add" component={PackageForm}/>
                        <Route path="/package/:id/details" component={PackageDetails}/>
                        <Route path="/package/:id/update" component={UpdatePackage}/>
                        <Route path="/rate" component={Rate}/>
                        <Route path="/status-list" component={StatusList}/>
                    </Switch>
                </Container>
            </BrowserRouter>
        );
    }

    logout = () => {
        Storage.clear();
        window.location.replace('/');
    };

    handleShowProfile = () => {
        this.setState({showProfile: true})
    };

    handleCloseProfile = () => {
        this.setState({showProfile: false});
    };
}

export default App;
